// Busca un producto por su código de barras (EAN-13, EAN-8, UPC-A...)
// en Open Food Facts. Devuelve null si no existe o si le faltan los
// datos nutricionales imprescindibles (kcal), para no guardar un
// alimento con calorías a 0 que falsee los cálculos del paciente.
export async function lookupBarcode(codigo) {
  try {
    const res = await fetch(`https://world.openfoodfacts.org/api/v0/product/${encodeURIComponent(codigo)}.json`)
    const data = await res.json()

    if (data.status !== 1 || !data.product) return null

    const product = data.product
    const n = product.nutriments ?? {}
    const kcal = n['energy-kcal_100g'] ?? n['energy-kcal']
    const nombre = product.product_name || product.product_name_es || product.generic_name

    if (!nombre || kcal == null) return null

    return {
      id: 'barcode_' + codigo,
      nombre,
      kcal_100g: Math.round(kcal),
      proteina_100g: Math.round((n.proteins_100g ?? 0) * 10) / 10,
      grasa_100g: Math.round((n.fat_100g ?? 0) * 10) / 10,
      carbohidratos_100g: Math.round((n.carbohydrates_100g ?? 0) * 10) / 10,
      fuente: 'openfoodfacts',
      codigo,
    }
  } catch (e) {
    console.error('Open Food Facts error:', e)
    return null
  }
}

export async function saveBarcodeFood(food, supabase) {
  const { data: existing } = await supabase
    .from('foods')
    .select('id')
    .eq('nombre', food.nombre)
    .single()

  if (existing) return existing.id

  const { data } = await supabase
    .from('foods')
    .insert({
      nombre: food.nombre,
      kcal_100g: food.kcal_100g,
      proteina_100g: food.proteina_100g,
      grasa_100g: food.grasa_100g,
      carbohidratos_100g: food.carbohidratos_100g,
      fuente: 'openfoodfacts',
    })
    .select('id')
    .single()

  return data?.id
}
